// extracted by mini-css-extract-plugin
export default {"cont":"Usage_cont__nWTpD","details":"Usage_details__-2jMz"};